import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { firestore } from 'firebase';
@Injectable({
  providedIn: 'root'
})
export class EmployerService {

  editJobData;
  baseUrl;

  constructor(private http: HttpClient, private auth: AuthService, private afs: AngularFirestore) {
    if (environment.production) {
      this.baseUrl = ''
    } else {
      this.baseUrl = 'http://localhost:5000'
    }
  }

  setEmployerDetails(data) {
    console.log(data)
    return this.http.post(`${this.baseUrl}/api/createEmployer`, data, { responseType: 'json' });
  }

  updateEmployerDetails(data) {
    return this.http.post(`${this.baseUrl}/api/updateEmployer`, data, { responseType: 'json' });
  }

  getEmployerDetails(id) {
    return this.http.post(`${this.baseUrl}/api/getEmployer`, id, { responseType: 'json' });
  }

  getJobFAQs(query) {
    return this.http.post(`${this.baseUrl}/api/searchFAQs`, query, { responseType: 'json' })
  }
  postJobFAQs(query) {
    return this.http.post(`${this.baseUrl}/api/postFAQs`, query, { responseType: 'json' })
  }
  postJob(query) {
    return this.http.post(`${this.baseUrl}/api/postjob`, query, { responseType: 'json' })
  }
  getPostJob(query) {
    return this.http.post(`${this.baseUrl}/api/getPostjob`, query, { responseType: 'json' })
  }

  private jobDataSource = new BehaviorSubject<any>({});
  jobData = this.jobDataSource.asObservable();


  updateJobData(data) {
    this.jobDataSource.next(data);
    // console.log(data);
  };

  getSkills() {
    return this.afs.collection('skills').doc('skills').valueChanges()
    //return this.http.get('/api/getSkills');
  };

  updateSkills(data) {
    return this.afs.collection('skills').doc('skills').update({"skills":firestore.FieldValue.arrayUnion(data)})
    //return this.http.post('/api/updateSkills', data, { responseType: 'text' });
  }

  getLocations(input) {
    let proxyUrl = 'https://cors-anywhere.herokuapp.com/';
    return this.http.get(`${proxyUrl}https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${input}&key=AIzaSyDEqWPsLUkNV3Ut3KfELN7HPo8stdpV8lE&sessiontoken=1234567890`)
  }

  updateJob(data) {
    return this.http.post(`${this.baseUrl}/api/jobUpdate`, data, { responseType: 'json' })
  }
  deleteJob(data) {
    return this.http.post(`${this.baseUrl}/api/deleteJob`, data, { responseType: 'json' })
  }


  getJobRoles(jobType) {
    return this.afs.collection('job-roles', ref => ref.where('job-type', '==', jobType)).valueChanges()
  }

  getJobTypes() {
    return this.afs.collection('job-types').valueChanges();
  }

  getJobDetails(_id) {
    return this.http.post(`${this.baseUrl}/api/getJobDetails`, _id)
  }

  getAllJobRoles() {
    return this.afs.collection('job-roles').valueChanges()
  }

  searchCandidates(searchQuery) {
    return this.http.post(`${this.baseUrl}/api/searchCandidates`, searchQuery)
  }

  getCandidateById(query) {
    return this.http.post(`${this.baseUrl}/api/getCandidateById`, query)
  }

  updateJobDetails(data) {
    return this.http.post(`${this.baseUrl}/api/updateJobPost`, data)
  }
  
  createJobApplicantDetails(data){
    return this.http.post(`${this.baseUrl}/api/createJobApplicant`,data)
  }

  getJobApplicantsDetails(data){
    return this.http.post(`${this.baseUrl}/api/getJobApplicants`,data)
  }
}